/**
 *
 */
class AbstractError extends Error {
  /**
   *
   * @param {number} code
   * @param {Array} params
   */
  constructor(code, ...params) {
    super(...params);
    if (Error.captureStaceTrace) {
      Error.captureStackTrace(this, AbstractError);
    }

    this.code = code;
    this.timestamp = new Date();
    this.name = this.constructor.name;
  }
}

export default AbstractError;



// WEBPACK FOOTER //
// ./abstract-error/src/AbstractError/index.js